import { render, staticRenderFns } from "./inmueble-burbuja.vue?vue&type=template&id=20699f58&"
import script from "./inmueble-burbuja.vue?vue&type=script&lang=js&"
export * from "./inmueble-burbuja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports